<template>
  <div>
    <div class="d-flex flex-column">
      <div class="section">
        <div class="monthlyHoroscope">
          <div class="heroElmWrap">
            <img class="horo_image" :src="current_year.image_year" />
            <img
              class="sumdge"
              src="../../assets/mobiscope/imgs/smudge_overlay-orange.png"
            />
          </div>
          <div class="container">
            <div class="monthlyHoroscope__content">
              <h1 class="std__title yellow">{{ current_year[`sign_${language}`] }}</h1>
              <h2 class="std__subtile">{{$t("zodiac_of_the_year")}}</h2>
              <p class="horoscope" >{{ current_year.health[`${language}`] }}</p>
              <router-link
                class="btn btn-lg stdBtn yellow"
                style="text-decoration:none;"
                :to="{
                  name: 'ChineseZodiacDetails',
                  params: { chinesesign: current_year.route }
                }"
                >{{$t("read_more")}}</router-link>
            </div>
          </div>
        </div>
      </div>
      <div class="section">
        <div class="container">
          <div class="section__content center">
            <h2 class="std__subtile">{{$t("chinese_zodiac_signs")}}</h2>
            <div class="row">
              <div
                class="col-3 col-md-2"
                v-for="zodiac in czodiacs"
                :key="zodiac.key"
              >
                <router-link
                  class="signIcon yellow"
                  style="text-decoration:none;"
                  :to="{
                    name: 'ChineseZodiacDetails',
                    params: { chinesesign: zodiac.sign_english.toLowerCase() }
                  }"
                >
                  <span
                    class="signIcon__img"
                    :style="{ '-webkit-mask': `url(${zodiac.image})` }"
                  ></span>
                  <span class="shadow"></span>
                  <div class="signIcon__label">{{ zodiac[`sign_${language}`] }}</div>
                  <!-- <img class="zodiac_img" :src="zodiac.image" alt /> -->
                  <!-- <p id="animals">{{zodiac.sign}}</p> -->
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import zodiacs from "./zodiac.json";
import { mapGetters,mapActions } from "vuex";

let currentDate = new Date();
let year = currentDate.getFullYear();

export default {
  data() {
    return {
      current_year: {},
      year: year,
      czodiacs: {},
    };
  },
  computed: mapGetters(["language"]),
  created() {
    //to get zodiac information
    var getzodiac = require('getzodiac');
    let czanimal = getzodiac(this.year)

    let cz = zodiacs.eastern_zodiac;
    this.getCZodiac(cz, czanimal);
  },
  methods: {
    getCZodiac(cz, czanimal) {
      //get all zodiac
      for (let i = 0; i < cz.length; i++) {
        cz[i].image = require(`../../assets/mobiscope/imgs/cz_icon/${cz[i].sign_english}.svg`);
      }
      
      //zodiac of the year
      let ani = czanimal.en
      czanimal = ani.replace(/^./, ani[0].toUpperCase());

      cz.map((value)=>{
        if(value.sign_english == czanimal){
          value.image_year = require(`../../assets/mobiscope/imgs/cz_animal/${value.sign_english}.svg`);
          value.route = value.sign_english.toLowerCase()
          this.current_year = value
        }
      })
      this.czodiacs = cz;
    }
  }
};
</script>

<style scoped>
h3 {
  color: rgb(0, 204, 255);
}

.current_zodiac {
  height: 200px;
}

.zodiac_img {
  height: 100px;
}

.sumdge {
  max-width: 580px;
  width: 100%;
  right: 0;
}

li {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/mobiscope/ChineseZodiac.vue